exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal__header[data-v-67173dd6] {\n  font-family: Arial,Tahoma,sans-serif;\n  font-weight: 100;\n  font-size: 24px;\n  line-height: 24px;\n  font-size: 24px;\n}\n.modal__body[data-v-67173dd6] {\n  padding: 20px;\n}\n", ""]);

// exports
